'use client';

import type { ImageLoaderProps } from 'next/image';

const loader = ({ src, width, quality }: ImageLoaderProps) => {
  if (!src) {
    return src;
  }

  let url: URL;
  try {
    url = new URL(src);
  } catch {
    // Relative sources (local imports, static placeholders) are served as-is.
    return src;
  }

  if (!url.hostname.includes('media.ci.org')) {
    return src;
  }

  // images from CI already include some optimizations
  // make some adjustments here to fetch a hard width and quality
  const parts = url.pathname.split('/');
  const replaceIndex = parts.findIndex((p) => p.includes('f_auto'));
  if (replaceIndex !== -1) {
    parts[replaceIndex] = `f_auto,q_${quality || 75},c_scale,w_${width}`;
    url.pathname = parts.join('/');
  }

  return url.toString();
};

export default loader;
